/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Match_Resume_LabelInputs */

const en_deep_match_resume_label = /** @type {(inputs: Deep_Match_Resume_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume`)
};

const de_deep_match_resume_label = /** @type {(inputs: Deep_Match_Resume_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume`)
};

const fr_deep_match_resume_label = /** @type {(inputs: Deep_Match_Resume_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume`)
};

const es_deep_match_resume_label = /** @type {(inputs: Deep_Match_Resume_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume`)
};

const it_deep_match_resume_label = /** @type {(inputs: Deep_Match_Resume_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume`)
};

const nl_deep_match_resume_label = /** @type {(inputs: Deep_Match_Resume_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume`)
};

const pl_deep_match_resume_label = /** @type {(inputs: Deep_Match_Resume_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume`)
};

const fi_deep_match_resume_label = /** @type {(inputs: Deep_Match_Resume_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume`)
};

const da_deep_match_resume_label = /** @type {(inputs: Deep_Match_Resume_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume`)
};

const sv_deep_match_resume_label = /** @type {(inputs: Deep_Match_Resume_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume`)
};

/**
* | output |
* | --- |
* | "Resume" |
*
* @param {Deep_Match_Resume_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_resume_label = /** @type {((inputs?: Deep_Match_Resume_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_Resume_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_resume_label(inputs)
	if (locale === "fr") return fr_deep_match_resume_label(inputs)
	if (locale === "es") return es_deep_match_resume_label(inputs)
	if (locale === "it") return it_deep_match_resume_label(inputs)
	if (locale === "nl") return nl_deep_match_resume_label(inputs)
	if (locale === "pl") return pl_deep_match_resume_label(inputs)
	if (locale === "fi") return fi_deep_match_resume_label(inputs)
	if (locale === "da") return da_deep_match_resume_label(inputs)
	if (locale === "sv") return sv_deep_match_resume_label(inputs)
	return en_deep_match_resume_label(inputs)
});